import { Form, Input } from "antd";
import { useIntl } from "react-intl";

import { FormFieldContainer } from "./styled";

export const PercentCompleteSliderEditFormField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name={["property", "label", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "requiredValidationText", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
    </FormFieldContainer>
  );
};
